import cx from "classnames";
import React from "react";

import { QuestionAndAnswer } from "@/mk2/apps/strollers/components/QuestionAndAnswer";
import { StrollerQuestionEntity } from "@/mk2/apps/strollers/schemas";
import {
    STROLLER_MORE_QUESTIONS,
    STROLLER_QUESTIONS_AND_ANSWERS,
} from "@/mk/autogenerated/translations/QuestionsAndAnswers.bb79755ca48946242b7f22ace771f4f9";

import styles from "./QuestionsAndAnswers.mscss";

interface OwnProps {
    className?: string;
    questions: StrollerQuestionEntity[];
    addButton?: React.ReactNode;
}

interface State {
    expanded: boolean;
}

type Props = OwnProps;

const LIMIT = 3;

export class QuestionsAndAnswers extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            expanded: false,
        };
    }

    public render() {
        const { className, questions: allQuestions, addButton } = this.props;

        if (allQuestions.length === 0) {
            return null;
        }

        const shownQuestions = this.state.expanded ? allQuestions : allQuestions.slice(0, LIMIT);
        const showMoreQuestions = allQuestions.length > shownQuestions.length;

        return (
            <div className={cx(styles.QuestionsAndAnswers, className)}>
                <div className={styles.QuestionsAndAnswers__textBox}>
                    <h2 className={styles.QuestionsAndAnswers__headline}>
                        {STROLLER_QUESTIONS_AND_ANSWERS}
                    </h2>
                </div>

                <div className={styles.QuestionsAndAnswers__questions}>
                    {shownQuestions.map((question, idx) => {
                        return (
                            <QuestionAndAnswer
                                key={idx}
                                question={question.question}
                                answer={question.answer}
                            />
                        );
                    })}
                </div>

                <div
                    className={cx(
                        styles.QuestionsAndAnswers__footer,
                        !showMoreQuestions && styles["QuestionsAndAnswers__footer--noMore"],
                    )}
                >
                    {showMoreQuestions && (
                        <button
                            className={styles.QuestionsAndAnswers__expand}
                            onClick={this.expand}
                        >
                            {STROLLER_MORE_QUESTIONS} ({allQuestions.length - shownQuestions.length}
                            )
                        </button>
                    )}

                    {addButton}
                </div>
            </div>
        );
    }

    private expand = () => {
        this.setState({ expanded: true });
    };
}
